<template>
  <div>
    <b-container>
      <b-row align-h="center">
        <b-col cols="10">
          <b-button class="back mt-2 mb-4" variant="primary" @click="back">Back To Quotations</b-button>
          <b-button class="ml-2 mt-2 mb-4" variant="primary" @click="edit">Edit</b-button>
          <b-button class="ml-2 mt-2 mb-4" 
            variant="success" 
            @click="generateCRMOrder" 
            v-if="!(quote.orderId != null && quote.orderId.length > 0)">
            Generate CRM Order
          </b-button>
          <b-button class="ml-2 mt-2 mb-4" 
            variant="success" 
            @click="viewOrder"
            v-if="quote.orderId != null && quote.orderId.length > 0">
            View Linked Order
          </b-button>
          <!-- <b-button class="back ml-2 mt-2 mb-4" variant="primary" @click="print">Print</b-button> -->
          <b-row align-h="center">
            <b-col>
              <img src="../assets/StonemartLogo.png">
            </b-col>
            <b-col>
              <b-row>
                <b-col cols="12">
                  <strong>Stonemart Memorial</strong>
                </b-col>
                <b-col cols="12">
                  <strong>310 Mahoneys Road Thomastown VIC 3074</strong>
                </b-col>
                <b-col cols="12">
                  <strong>1300 696 896</strong>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <br>
          <b-row align-h="center" class="mt-4">
            <b-col>
              <b-row align-h="begin">
                <b-col cols="12">
                  <strong>Customer Name: </strong>{{quote.customer_name}}
                </b-col>
                <b-col cols="12">
                  <strong>Customer Phone: </strong>{{quote.customer_phone}}
                </b-col>
                <b-col cols="12">
                  <strong>Cemetery: </strong>{{quote.customer_cemetery}}
                </b-col>
                <b-col cols="12">
                  <strong>Section: </strong>{{quote.customer_section}}
                </b-col>
                <b-col cols="12">
                  <strong>Row: </strong>{{quote.customer_row}}
                </b-col>
                <b-col cols="12">
                  <strong>Grave No: </strong>{{quote.customer_grave_number}}
                </b-col>
                <b-col cols="12">
                  <strong>Funeral Provider: </strong>{{quote.customer_funeral_provider}}
                </b-col>
                <b-col cols="12">
                  <strong>How did you find us? </strong>{{quote.customer_how_find}}
                </b-col>
                <b-col cols="12">
                  <strong>Comment: </strong>{{quote.customer_comment}}
                </b-col>
              </b-row>
            </b-col>
            <b-col>
              <b-row align-h="end">
                <b-col cols="12">
                  <strong>Style: </strong>{{quote.monument_style}}
                </b-col>
                <b-col cols="12">
                  <strong>Sales: </strong>{{quote.created_by_name}}
                </b-col>
                <b-col cols="12">
                  <strong>Created date: </strong>{{quote.create_date}}
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <br>
          <div class="mt-4 p-0">
            <div v-if="quote.materials.length > 0" class="monument bordered">
              <b-row>
                <b-col class="quote-item-row-divider-vertical">
                  <strong>Monument</strong>
                </b-col>
                <b-col cols="2" class="text-right">
                  <strong>Price</strong>
                </b-col>
              </b-row>
              <b-row v-for="(material, index) in quote.materials" :key="'material' + index">
                <b-col class="quote-item-row-left">
                  <span v-if="quote.monument_type != null">{{quote.monument_type}} - </span>{{material.name}}<span> - {{material.size}} - {{material.usage}}</span>
                </b-col> 
                <b-col class="text-right quote-item-row-right" cols="2">
                  {{material.total_price}}
                </b-col>
              </b-row>
            </div>
            <div v-if="quote.quote_discount > 0" class="discount bordered">
              <b-row>
                <b-col class="quote-item-row-divider-vertical">
                  <strong>Material Discount</strong>
                </b-col>
                <b-col cols="2" class="text-right">
                  {{quote.quote_discount}}% off
                </b-col>
              </b-row>
            </div>
            <div v-if="quote.installations.length > 0" class="Installation bordered">
              <b-row>
                <b-col class="quote-item-row-divider-vertical">
                  <strong>Installation</strong>
                </b-col>
                <b-col cols="2"></b-col>
              </b-row>
              <b-row v-for="(installation, index) in quote.installations" :key="'installation' + index">
                <b-col class="quote-item-row-left">
                  {{installation.name}}
                </b-col>
                <b-col class="text-right quote-item-row-right" cols="2">
                  {{installation.price}}
                </b-col>
              </b-row>
            </div>
            <div v-if="quote.inscriptions.length > 0" class="Inscription bordered">
              <b-row>
                <b-col class="quote-item-row-divider-vertical">
                  <strong>Inscription</strong>
                </b-col>
                <b-col cols="2"></b-col>
              </b-row>
              <b-row v-for="(inscription, index) in quote.inscriptions" :key="'inscription' + index">
                <b-col class="quote-item-row-left">
                  {{inscription.name}}
                </b-col>
                <b-col class="text-right quote-item-row-right" cols="2">
                  <span v-if="inscription.name == '[Per Letter]Under 40 letters(& included 40 letters)'">
                    200 + 
                  </span>
                  {{inscription.price}} * {{inscription.number}}
                </b-col>
              </b-row>
            </div>
            <div v-if="quote.accessories.length > 0" class="Accessory bordered">
              <b-row>
                <b-col class="quote-item-row-divider-vertical">
                  <strong>Accessory</strong>
                </b-col>
                <b-col cols="2"></b-col>
              </b-row>
              <b-row v-for="(accessory, index) in quote.accessories" :key="'accessory' + index">
                <b-col class="quote-item-row-left">
                  {{accessory.name}} - {{accessory.size}} * {{accessory.quantity}}
                </b-col>
                <b-col class="text-right quote-item-row-right" cols="2">
                  {{accessory.total_price}}
                </b-col>
              </b-row>
            </div>
            <div v-if="quote.castings.length > 0" class="Casting bordered">
              <b-row>
                <b-col class="quote-item-row-divider-vertical">
                  <strong>Carving</strong>
                </b-col>
                <b-col cols="2"></b-col>
              </b-row>
              <b-row v-for="(casting, index) in quote.castings" :key="'casting' + index">
                <b-col class="quote-item-row-left">
                  {{casting.name}}
                </b-col>
                <b-col class="text-right quote-item-row-right" cols="2">
                  {{casting.price}}
                </b-col>
              </b-row>
            </div>
            <div v-if="quote.permit_fee > 0" class="permit-fee bordered">
              <b-row>
                <b-col class="quote-item-row-divider-vertical">
                  <strong>Permit Fee</strong>
                </b-col>
                <b-col cols="2" class="text-right">
                  {{quote.permit_fee}}
                </b-col>
              </b-row>
            </div>
            <div v-if="quote.foundations.length > 0" class="Foundation bordered">
              <b-row>
                <b-col class="quote-item-row-divider-vertical"> 
                  <strong>Foundation</strong>
                </b-col>
                <b-col cols="2"></b-col>
              </b-row>
              <b-row v-for="(foundation, index) in quote.foundations" :key="'foundation' + index">
                <b-col class="quote-item-row-left">
                  {{foundation.name}}
                </b-col>
                <b-col class="text-right quote-item-row-right" cols="2">
                  {{foundation.price}}
                </b-col>
              </b-row>
            </div>
            <div class="extra-fee bordered" v-if="quote.extra_fee != null && quote.extra_fee > 0">
              <b-row>
                <b-col class="quote-item-row-divider-vertical">
                  <strong>Extra Fee</strong>
                </b-col>
                <b-col  cols="2" class="text-right">
                  {{quote.extra_fee}}
                </b-col>
              </b-row>
              <b-row>
                <b-col class="quote-item-row-divider-vertical">
                  {{quote.extra_fee_description}}
                </b-col>
                <b-col cols="2"></b-col>
              </b-row>
            </div>
            <div class="total-price bordered">
              <b-row>
                <b-col class="quote-item-row-divider-vertical">
                  <strong>Total Price</strong>
                </b-col>
                <b-col cols="2" class="text-right">
                  <strong>{{quote.total_price}}</strong>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>

    <b-modal size="lg" id="generate-order" title="New Order" hide-footer>
      <b-form @submit.prevent="generateCRMOrderTask">
        <b-row>
          <b-col cols="4" v-for="item in createOrderFormInputs" :key="item.key">
            <label :for="`new-order-input-${item.key}`">{{item.label}}<span style="color: red" v-if="item.mandatory">*</span></label>
            <b-form-input v-if="item.form_type == 'text-input'" :id="`new-order-input-${item.key}`" :type="item.type" v-model="newCRMOrder[item.key]" :required="item.mandatory" min="0.00"></b-form-input>
            <span v-if="item.form_type == 'text-input-list'">
              <b-form-input :id="`new-order-input-${item.key}`" :type="item.type" v-model="newCRMOrder[item.key]" :required="item.mandatory" :list="item.listName" min="0.00"></b-form-input>
              <datalist :id="item.listName">
                <option v-for="(option, index) in dataLists[item.listName]" :key="item.label + index">{{ option }}</option>
              </datalist>
            </span>
            <b-form-select v-if="item.form_type == 'select'"
              :id="`new-order-input-${item.key}`"
              v-model="newCRMOrder[item.key]" 
              :required="item.mandatory"
              :options="selectOptions[item.options]"
            ></b-form-select>
            <b-form-datepicker v-if="item.form_type == 'datepicker'"
              :id="`new-order-input-${item.key}`"
              v-model.trim="newCRMOrder[item.key]" 
              :required="item.mandatory"
              today-button
              reset-button
              close-button
            ></b-form-datepicker>
          </b-col>
          <b-col cols="12">
            <label for="new-order-description">Description<span style="color: red">*</span></label>
            <b-form-textarea
              id="new-order-description"
              v-model="newCRMOrder.description"
              rows="3"
              max-rows="6"
              :required="true"
            ></b-form-textarea>
          </b-col>
        </b-row>
        <div class="mt-4 modal-footer">
          <b-button @click="hideModal('generate-order')"> Cancel </b-button>
          <b-button class="ml-1" variant="success" type="submit">
            <span v-if="!isCreating">Create</span>
            <span v-if="isCreating">
              <b-spinner small type="grow"></b-spinner>
              Create...
            </span>
          </b-button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import firebase from "firebase/app";

export default {
  data() {
    return {
      dataLists: {
        suburbList: [],
        sectionList: [],
      },
      leadSourceNames: [],
      storeLocationNames: [],
      funeralServiceProviderNames: [],
      cemeteries: [],
      job_styles: [],
      selectOptions: {
        foundations: ['', 'Done by Cemetery', 'Done by Steve', 'Need Foundation', 'Additional Inscriptions'],
        salesNames: [],
        leadSourceNames: [],
        storeLocationNames: [],
        funeralServiceProviderNames: [],
        cemeteries: [],
        jobStyles:[],
      },
      salesNames: [],
      isCreating: false,
      newCRMOrder: {
        monumentDoneDate: "",
        monumentInstaller: "",
        ashlarDoneDate: "",
        ashlarInstaller: "",
        inscriptionDoneDate: "",
        inscriptionInstaller: "",
        installationNote: "",
        status: "active",
        cemetery: "",
        section: "",
        row: "",
        grave: "",
        style: "",
        files: [],
        comments: [],
        complaints: [],
        installations: [],
        id: "",
        createDate: "",
        createDateTimestamp: null,
        histories: [],
        emailHistories: [],
        fileHistories: [],
        customerTitle: "",
        customerFirstName: "",
        customerLastName: "",
        creater: this.user,
        sales: null,
        salesName: this.user.name,
        phone: "",
        email: "",
        address: "",
        suburb: "",
        state: "",
        postcode: "",
        deceasedName: "",
        leadSource: "",
        invoiceNumber: "",
        invoiceDate: "",
        itemCode: "",
        totalAmount: 0,
        outstandingAmount: 0,
        firstPaymentDate: "",
        secondPaymentDate: "",
        FinalPaymentDate: "",
        description: "",
        funeralServiceProvider: "",
        orderingManufacturer: "",
        orderingStoreLocation: "",
        orderingOrderDate: "",
        orderingConfirmDate: "",
        orderingETA: "",
        orderingContainerNumber1: "",
        orderingContainerNumber2: "",
        orderingContainerNumber3: "",
        orderingCrateNumber1: "",
        orderingCrateNumber2: "",
        orderingCrateNumber3: "",
        orderingUnloadStore: "",
        orderingDispatchDate: "",
        orderingATA: "",
      },
      createOrderFormInputs: [
        { key: "customerFirstName", label: "First Name", type: "text", form_type: "text-input", mandatory: true },
        { key: "customerLastName", label: "Last Name", type: "text", form_type: "text-input", mandatory: true },
        { key: "salesName", label: "Sales", type: "text", form_type: "select", options:'salesNames', mandatory: true},
        { key: "phone", label: "Phone", type: "text", form_type: "text-input", mandatory: false },
        { key: "email", label: "Email", type: "text", form_type: "text-input", mandatory: false },
        { key: "address", label: "Address", type: "text", form_type: "text-input", mandatory: false },
        { key: "suburb", label: "Suburb", type: "text", form_type: "text-input-list", listName: "suburbList", mandatory: true },
        { key: "state", label: "State", type: "text", form_type: "text-input", mandatory: false },
        { key: "postcode", label: "Postcode", type: "text", form_type: "text-input", mandatory: false },
        { key: "deceasedName", label: "Deceased Name", type: "text", form_type: "text-input", mandatory: true },
        { key: "leadSource", label: "Lead Source", type: "text", form_type: "select", options:'leadSourceNames', mandatory: true },
        { key: "invoiceNumber", label: "Invoice Number", type: "text", form_type: "text-input", mandatory: true },
        { key: "invoiceDate", label: "Invoice Date", type: "text", form_type: "datepicker", mandatory: true },
        { key: "itemCode", label: "Item Code", type: "text", form_type: "text-input", mandatory: false },
        { key: "totalAmount", label: "Total Amount", type: "number", form_type: "text-input", mandatory: true },
        { key: "outstandingAmount", label: "Outstanding Amount", type: "number", form_type: "text-input", mandatory: true },
        { key: "firstPaymentDate", label: "First Payment Date", type: "text", form_type: "datepicker", mandatory: false },
        { key: "cemetery", label: "Cemetery", type: "text", form_type: "select", options:'cemeteries', mandatory: false },
        { key: "foundation", label: "Foundation", type: "text", form_type: "select", options:'foundations', mandatory: false },
        { key: "funeralServiceProvider", label: "Funeral Service", type: "text", form_type: "select", options:'funeralServiceProviderNames', mandatory: true },
        { key: "section", label: "Section", type: "text", form_type: "text-input-list", listName: "sectionList", mandatory: false },
        { key: "row", label: "Row", type: "text", form_type: "text-input", mandatory: false },
        { key: "grave", label: "Grave", type: "text", form_type: "text-input", mandatory: false },
        { key: "style", label: "Style", type: "text", form_type: "select", options:'jobStyles', mandatory: false },
        // { key: "description", label: "Description", type: "text", mandatory: true },
      ],
    }
  },
  name: "ExportQuote",
  props: {
    user: Object,
    quote: Object,
    from: String,
    viewedOrder: Object,
  },
  created() {
    const now = new Date();
    const dd = String(now.getDate()).padStart(2, "0");
    const mm = String(now.getMonth() + 1).padStart(2, "0");
    const yyyy = now.getFullYear();
    this.today = yyyy + "-" + mm + "-" + dd;

    firebase
      .firestore()
      .collection("saless")
      .onSnapshot((collection) => {
        this.sales = collection.docs.map((doc) => doc.data());
        for (var i = 0; i < this.sales.length; i++) {
          this.salesNames.push(this.sales[i].name);
          this.selectOptions.salesNames.push(this.sales[i].name);
        }
      });

      firebase
      .firestore()
      .collection("lead_sources")
      .orderBy("name")
      .onSnapshot((collection) => {
        this.leadSources = collection.docs.map((doc) => doc.data());
        for (var i = 0; i < this.leadSources.length; i++) {
          this.leadSourceNames.push(this.leadSources[i].name);
          this.selectOptions.leadSourceNames.push(this.leadSources[i].name);
        }
      });

    firebase.firestore().collection('store_locations').orderBy('name').onSnapshot((collection) => {
      this.storeLocations = collection.docs.map(doc => doc.data());
      for (var i = 0; i < this.storeLocations.length; i++) {
        this.storeLocationNames.push(this.storeLocations[i].name);
        this.selectOptions.storeLocationNames.push(this.storeLocations[i].name);
      }
    });

    firebase
      .firestore()
      .collection("funeral_providers")
      .orderBy("name")
      .onSnapshot((collection) => {
        this.funeralServiceProviders = collection.docs.map((doc) => doc.data());
        for (var i = 0; i < this.funeralServiceProviders.length; i++) {
          this.funeralServiceProviderNames.push(this.funeralServiceProviders[i].name);
          this.selectOptions.funeralServiceProviderNames.push(this.funeralServiceProviders[i].name);
        }
      });

    firebase.firestore().collection('job_styles').orderBy('name').onSnapshot((collection) => {
      const job_style_objs = collection.docs.map(doc => doc.data());
      for (var i = 0; i < job_style_objs.length; i++) {
        this.job_styles.push(job_style_objs[i].name);
        this.selectOptions.jobStyles.push(job_style_objs[i].name);
      }
    });

    firebase.firestore().collection('cemeteries').orderBy('name').onSnapshot((collection) => {
      const cemeterie_objs = collection.docs.map(doc => doc.data());
      for (var i = 0; i < cemeterie_objs.length; i++) {
        this.cemeteries.push(cemeterie_objs[i].name);
        this.selectOptions.cemeteries.push(cemeterie_objs[i].name);
      }
    });
    
    firebase
      .firestore()
      .collection("datalists")
      .onSnapshot((collection) => {
        console.log("list start");
        const lists = collection.docs.map((doc) => doc.data());
        for (var i = 0; i < lists.length; i++) {
          if (lists[i].name == 'suburbList') {
            this.dataLists.suburbList = lists[i].suburbList;
          }
          if (lists[i].name == 'sectionList') {
            this.dataLists.sectionList = lists[i].sectionList;
          }
        }
      });
  },
  methods: {
    back() {
      this.$emit('ChangeSystem', 'installation');
      this.$emit("backTo", this.from);
    },
    edit() {
      var event = {quote: this.quote};
      this.$emit("editQuote", event);
    },
    print() {
      window.print();
    },
    hideModal(id) {
      this.$bvModal.hide(id);
    },
    showModal(id) {
      this.$bvModal.show(id);
    },
    viewOrder() {
      firebase.firestore().collection("crm_orders").doc(this.quote.orderId).get().then((data) => {
        this.$emit("CRMViewOrder", {id: data.data().id, from: 'Quotes'});
      });
    },
    generateCRMOrder() {
      this.newCRMOrder.customerFirstName = this.quote.customer_name.split(' ')[0];
      this.newCRMOrder.customerLastName = this.quote.customer_name.split(' ')[1];
      this.newCRMOrder.sales = this.quote.created_by;
      this.newCRMOrder.salesName = this.quote.created_by_name;
      this.newCRMOrder.phone = this.quote.customer_phone;
      this.newCRMOrder.email = this.quote.customer_email;
      this.newCRMOrder.leadSource = this.quote.customer_how_find;
      this.newCRMOrder.totalAmount = parseInt(this.quote.total_price);
      this.newCRMOrder.funeralServiceProvider = this.quote.customer_funeral_provider;
      this.newCRMOrder.description = this.quote.customer_comment;
      this.newCRMOrder.cemetery = this.quote.customer_cemetery;
      this.newCRMOrder.section = this.quote.customer_section;
      this.newCRMOrder.row = this.quote.customer_row;
      this.newCRMOrder.grave = this.quote.customer_grave_number;
      this.showModal('generate-order');
    },
    generateCRMOrderTask() {
      this.isCreating = true;
      const newCRMOrderRef = firebase
        .firestore()
        .collection("crm_orders")
        .doc();

      this.newCRMOrder.id = newCRMOrderRef.id;
      this.newCRMOrder.sales = this.sales[this.salesNames.indexOf(this.newCRMOrder.salesName)];
      this.newCRMOrder.createDate = this.today;
      this.newCRMOrder.createDateTimestamp = new Date(this.today);
      if (this.newCRMOrder.suburb.length > 0) this.newCRMOrder.suburb = this.newCRMOrder.suburb[0].toUpperCase() + this.newCRMOrder.suburb.slice(1);
      if (this.newCRMOrder.section.length > 0) this.newCRMOrder.section = this.newCRMOrder.section[0].toUpperCase() + this.newCRMOrder.section.slice(1);
      // this.newCRMOrder.orderDate = this.today;
      const tempOrder = Object.assign({}, this.newCRMOrder);
      delete tempOrder.histories;
      tempOrder.editor = this.user;
      tempOrder.editDate = this.today;
      this.newCRMOrder.histories.push(tempOrder);

      if (this.newCRMOrder.invoiceDate != null && this.newCRMOrder.invoiceDate.length > 0) {
        this.newCRMOrder.invoiceTime = new Date(this.newCRMOrder.invoiceDate);
      }

      const newSimplifiedOrderRef = firebase
        .firestore()
        .collection("crm_orders_simplified")
        .doc(this.newCRMOrder.id);

        let newSimplifiedOrder = {
          id: this.newCRMOrder.id? this.newCRMOrder.id : "",
          cemetery: this.newCRMOrder.cemetery? this.newCRMOrder.cemetery : "", 
          customerFirstName: this.newCRMOrder.customerFirstName? this.newCRMOrder.customerFirstName : "", 
          customerLastName: this.newCRMOrder.customerLastName? this.newCRMOrder.customerLastName : "", 
          deceasedName: this.newCRMOrder.deceasedName? this.newCRMOrder.deceasedName : "", 
          grave: this.newCRMOrder.grave, 
          invoiceNumber: this.newCRMOrder.invoiceNumber? this.newCRMOrder.invoiceNumber : "", 
          salesName: this.newCRMOrder.salesName? this.newCRMOrder.salesName : "", 
          style: this.newCRMOrder.style? this.newCRMOrder.style : "", 
          section: this.newCRMOrder.section? this.newCRMOrder.section : "", 
          row: this.newCRMOrder.row, 
          orderingContainerNumber1: this.newCRMOrder.orderingContainerNumber1? this.newCRMOrder.orderingContainerNumber1 : "", 
          orderingContainerNumber2: this.newCRMOrder.orderingContainerNumber2? this.newCRMOrder.orderingContainerNumber2 : "", 
          orderingContainerNumber3: this.newCRMOrder.orderingContainerNumber3? this.newCRMOrder.orderingContainerNumber3 : "", 
          invoiceDate: this.newCRMOrder.invoiceDate? this.newCRMOrder.invoiceDate : "", 
          orderDate: this.newCRMOrder.orderDate? this.newCRMOrder.orderDate : "", 
          docketNumber: this.newCRMOrder.docketNumber? this.newCRMOrder.docketNumber : "", 
          orderingInscriptionToFactory: this.newCRMOrder.orderingInscriptionToFactory? this.newCRMOrder.orderingInscriptionToFactory : "", 
          orderingManufacturer: this.newCRMOrder.orderingManufacturer? this.newCRMOrder.orderingManufacturer : "", 
          foundation: this.newCRMOrder.foundation? this.newCRMOrder.foundation : "", 
          totalAmount: this.newCRMOrder.totalAmount? this.newCRMOrder.totalAmount : 0, 
          outstandingAmount: this.newCRMOrder.outstandingAmount? this.newCRMOrder.outstandingAmount : 0, 
          // orderingStoreLocation: this.newCRMOrder.id, 
          // orderingCrateNumber1: this.newCRMOrder.id, 
          // orderingCrateNumber2: this.newCRMOrder.id, 
          // orderingCrateNumber3: this.newCRMOrder.id, 
          // description: this.newCRMOrder.id, 
          status: this.newCRMOrder.status? this.newCRMOrder.status : "",
          funeralServiceProvider: this.newCRMOrder.funeralServiceProvider? this.newCRMOrder.funeralServiceProvider : "",
        };

        if (this.newCRMOrder.invoiceTime) {
          newSimplifiedOrder.invoiceTime = this.newCRMOrder.invoiceTime;
        }

      newCRMOrderRef.set(this.newCRMOrder).then(() => {
        newSimplifiedOrderRef.set(newSimplifiedOrder);

        this.isCreating = false;
        this.hideModal("generate-order");
        alert("Create successfully");

        this.quote.orderId = this.newCRMOrder.id;
        const quoteRef = firebase.firestore().collection("quotes").doc(this.quote.id);
        quoteRef.set(this.quote, {merge: true}).then(() => {
          if (!this.dataLists.suburbList.includes(this.newCRMOrder.suburb) && this.newCRMOrder.suburb != "") {
            this.dataLists.suburbList.push(this.newCRMOrder.suburb);
            firebase.firestore().collection("datalists").doc("pMDl8MQ5rNsxrdK020ao")
              .set({suburbList: this.dataLists.suburbList},
                {merge: true});
          }

          if (!this.dataLists.suburbList.includes(this.newCRMOrder.section) && this.newCRMOrder.section != "") {
            this.dataLists.sectionList.push(this.newCRMOrder.section)
            firebase.firestore().collection("datalists").doc("E3QYIcTtYWivCtJBoBSy")
              .set({sectionList: this.dataLists.sectionList},
              {merge: true});
          }

          this.newCRMOrder = {
            ashlarDoneDate: "",
            ashlarInstaller: "",
            monumentDoneDate: "",
            monumentInstaller: "",
            inscriptionDoneDate: "",
            inscriptionInstaller: "",
            installationNote: "",
            status: "active",
            cemetery: "",
            section: "",
            row: "",
            grave: "",
            style: "",
            files: [],
            comments: [],
            complaints: [],
            installations: [],
            id: "",
            createDate: "",
            createDateTimestamp: null,
            histories: [],
            emailHistories: [],
            fileHistories: [],
            customerTitle: "",
            customerFirstName: "",
            customerLastName: "",
            creater: this.user,
            sales: null,
            salesName: this.user.name,
            phone: "",
            email: "",
            address: "",
            suburb: "",
            state: "",
            postcode: "",
            deceasedName: "",
            leadSource: "",
            invoiceNumber: "",
            invoiceDate: "",
            itemCode: "",
            totalAmount: 0,
            outstandingAmount: 0,
            firstPaymentDate: "",
            secondPaymentDate: "",
            FinalPaymentDate: "",
            description: "",
            funeralServiceProvider: "",
            orderingManufacturer: "",
            orderingStoreLocation: "",
            orderingOrderDate: "",
            orderingConfirmDate: "",
            orderingETA: "",
            orderingContainerNumber1: "",
            orderingContainerNumber2: "",
            orderingContainerNumber3: "",
            orderingCrateNumber1: "",
            orderingCrateNumber2: "",
            orderingCrateNumber3: "",
            orderingUnloadStore: "",
            orderingDispatchDate: "",
            orderingATA: "",
          }
        });
      });
    },
  },
}
</script>

<style scoped>
@media print {
  .back {
    visibility: hidden;
  }
}

.bordered {
  border: 1px black solid;
}

.quote-item-row-left {
  border-top: 1px black solid;
  border-right: 1px black solid;
  margin-left: 15px;
  padding: 0;
}

.quote-item-row-right {
  border-top: 1px black solid;
  margin-right: 15px;
  padding: 0;
}

.quote-item-row-divider-vertical {
  margin-left: 15px;
  margin-right: 15px;
  padding: 0;
  border-right: 1px black solid;
}


</style>